/**
 * LoadingSpinner - Animated loading indicator
 */

import './ui.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  inline?: boolean;
}

export function LoadingSpinner({ size = 'medium', text, inline = false }: LoadingSpinnerProps) {
  const sizeClass = `spinner-${size}`;

  return (
    <div className={`loading-spinner ${inline ? 'inline' : ''}`}>
      <div className={`spinner ${sizeClass}`} aria-hidden="true">
        <div className="spinner-ring"></div>
      </div>
      {text && <span className="spinner-text">{text}</span>}
    </div>
  );
}
